import React, { useState } from "react";
import { FiGlobe, FiShield } from "react-icons/fi";
import GeoRestrictionModal from "components/GeoRestrictionModal";

const GeoRestrictionButton = ({
	book,
	variant = "button", // "button" | "icon" | "menu-item"
	className = "",
	showLabel = true,
}) => {
	const [modalVisible, setModalVisible] = useState(false);

	const handleClick = () => {
		setModalVisible(true);
	};

	const handleCloseModal = () => {
		setModalVisible(false);
	};

	// Icon component
	const IconComponent = book?.geo_restricted ? FiShield : FiGlobe;
	const iconColor = book?.geo_restricted ? "text-orange-500" : "text-blue-500";

	// Button variants
	if (variant === "icon") {
		return (
			<>
				<button
					onClick={handleClick}
					className={`p-2 rounded-lg hover:bg-gray-100 transition-colors ${iconColor} ${className}`}
					title={book?.geo_restricted ? "Edit geo-restrictions" : "Add geo-restrictions"}
				>
					<IconComponent className="w-4 h-4" />
				</button>
				<GeoRestrictionModal
					visible={modalVisible}
					onHide={handleCloseModal}
					bookId={book?.id}
					bookTitle={book?.title}
				/>
			</>
		);
	}

	if (variant === "menu-item") {
		return (
			<>
				<button
					onClick={handleClick}
					className={`w-full flex items-center space-x-2 px-3 py-2 text-left hover:bg-gray-50 transition-colors ${className}`}
				>
					<IconComponent className={`w-4 h-4 ${iconColor}`} />
					{showLabel && (
						<span className="text-sm text-gray-700">
							{book?.geo_restricted ? "Edit Geo-Restrictions" : "Add Geo-Restrictions"}
						</span>
					)}
				</button>
				<GeoRestrictionModal
					visible={modalVisible}
					onHide={handleCloseModal}
					bookId={book?.id}
					bookTitle={book?.title}
				/>
			</>
		);
	}

	// Default button variant
	return (
		<>
			<button
				onClick={handleClick}
				className={`flex items-center space-x-2 px-3 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors ${className}`}
			>
				<IconComponent className={`w-4 h-4 ${iconColor}`} />
				{showLabel && (
					<span className="text-sm text-gray-700">
						{book?.geo_restricted ? "Edit Geo-Restrictions" : "Add Geo-Restrictions"}
					</span>
				)}
			</button>
			<GeoRestrictionModal
				visible={modalVisible}
				onHide={handleCloseModal}
				bookId={book?.id}
				bookTitle={book?.title}
			/>
		</>
	);
};

export default GeoRestrictionButton;
